export enum LinkType {
    Facebook,
    Instagram,
}
